import Configuracao from "../misc/Configuracao";
import { ClasseJudicialDto } from "../modelo/dto/ClasseJudicialDto";
import GabineteStore from "../store/GabineteStore";
import fetch from './AxiosAdapter';

class ClassesApi {



    async recuperarDescricaoDeClasses() {

        const classes = await fetch<ClasseJudicialDto[]>(Configuracao.urlClasses);
        return classes.data;
    }
}

export default new ClassesApi();